export default __webpack_public_path__ + "static/media/resourceForGettingStarted1.9106a807.png";